'use strict';

(function() {
	angular.module('onboarding.common')
		.directive('cobSetFocus', cobSetFocus);

	cobSetFocus.$inject = ['$timeout'];

	var $timeout;

	function cobSetFocus(_$timeout_) {
		$timeout = _$timeout_;

		return {
			scope: false,
			restrict: 'A',
			replace: false,
			link: linkFunction

		};
	}

	function linkFunction(scope, elem, attrs) {
		attrs.$observe('cobSetFocus',
			function(newValue) {
				if (newValue === 'true')
					$timeout(function() {
						elem[0].focus();
					});
			});
	}


})();
